import { type FC } from 'react';
import { ActionIcon, CopyButton, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

type CopyValueButtonProps = {
    label: string;
    value: string;
};

export const CopyValueButton: FC<CopyValueButtonProps> = ({ label, value }) => {
    return (
        <CopyButton
            value={value}
            timeout={2000}
        >
            {({ copied, copy }) => (
                <Tooltip
                    label={copied ? 'Скопировано' : 'Скопировать'}
                    position='top'
                    withArrow
                >
                    <ActionIcon
                        aria-label={copied ? `${label}: скопировано` : `Скопировать ${label}`}
                        color={copied ? 'green' : 'gray'}
                        size='sm'
                        variant='subtle'
                        onClick={copy}
                    >
                        {copied ? (
                            <IconCheck
                                aria-hidden
                                size={16}
                            />
                        ) : (
                            <IconCopy
                                aria-hidden
                                size={16}
                            />
                        )}
                    </ActionIcon>
                </Tooltip>
            )}
        </CopyButton>
    );
};
